<template>
  <div class="mainAll">
    <div class="header_h">
      <el-form inline class="form" size="small" @submit.native.prevent="getList(1)">
        <el-form-item label="状态:">
          <el-select v-model="searchQuery.isEnable" size="small" clearable @change="getList(1)">
            <el-option v-for="item in isqiyongoptions" :key="item.id" :value="item.id" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="文件名称:">
          <el-input v-model="searchQuery.fileName" size="small" clearable @input="getList(1)">
          </el-input>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" size="small" @click="uploadBtn">
            上传
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="midd">
      <el-table ref="multipleTable" :data="manualList" border highlight-current-row height="100%">
        <el-table-column label="上传时间" prop="uploadTime" min-width="120px" />
        <el-table-column prop="fileName" label="安装包" min-width="200px">
          <template slot-scope="{ row }">
            <div style="display:flex;align-items: center">
              <img :src="className(row)" style="flex-shrink:0;margin-right:6px" />
              <el-link type="primary" @click="update(row)">
                <span class="tabLinkSpan" :title="row.fileName">{{ row.fileName }}</span>
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" min-width="120px">
          <template #default="{ row }">
            <span>{{ ['启用', '禁用'][row.isEnable] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="sortNum" width="60" />
        <el-table-column label="备注" prop="remark" min-width="200px" />
        <el-table-column label="操作" align="center" min-width="160px">
          <template slot-scope="{ row }">
            <span v-if="row.isEnable === 1" style="cursor: pointer;color:var(--theme-color)" @click="enableBtn(row)">启用</span>
            <span v-if="row.isEnable === 0" style="cursor: pointer;color:var(--theme-color)" @click="disableBtn(row)">禁用</span>
            <span style="cursor: pointer;color:var(--theme-color);margin-left: 10px;" @click="update(row)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page-1">
      <el-pagination background :total="totalCount" :page-size="pageSize" :current-page="pageIndex"
        :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="getList" />
    </div>
    <!--修改 -->
    <el-dialog v-dialogDrag :title="downPlugTitle" :visible.sync="downPlugDialog" :before-close="clickClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
      <el-form ref="downPlugForm" :model="downPlugForm" label-width="60px" size="small">
        <el-form-item label="文件:" prop="fileUploaded">
          <el-upload ref="upload" v-loading="loading" :http-request="httpRequest" class="upload-file" accept=".pdf"
            :disabled="fileList.length == 1" :show-file-list="false" style="display: inline-block; margin: 0 10px"
            action="/">
            <el-button size="small" plain :disabled="fileList.length == 1">
              上传
            </el-button>
          </el-upload>
        </el-form-item>
        <el-table v-if="fileList.length > 0" :data="fileList" :show-header="false" max-height="200px">
          <el-table-column label="名称" prop="name">
            <template slot-scope="scope">
              <div style="width: 100%; display: flex; align-items: center">
                <img :src="className(scope.row)" style="flex-shrink:0;margin-right:6px" alt="" />
                <span style="width: 80%">{{ scope.row.fileName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope">
              <span style="width: 100%; display: flex; justify-content: flex-start">
                <i class="el-icon-download" title="下载" style="margin-right: 15px; color: var(--theme-color)"
                  @click="uploadRowType(scope.row)" />
                <i class="el-icon-delete" title="删除" style="color: #f54f45" @click="deleteRow(scope.$index)" />
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="备注:" prop="remark" style="margin-top:10px">
          <el-input v-model="downPlugForm.remark" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea"
            maxlength="200" size="small" />
        </el-form-item>
        <el-form-item label="序号">
          <el-input-number v-model="downPlugForm.sortNum" :min="0" :step="1" step-strictly style="width:100%" size="small" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="clickClose">取 消</el-button>
        <el-button type="primary" size="small" @click="sureChangeRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/CommonDP/service/admin/downPlug-service";
import { tableRowIcon } from "@/CommonDP/utils/docPublic";
import { downloadFile, scanzhizhao } from "@/CommonDP/utils";
export default {
  name: "AdminManualHelp",
  data() {
    return {
      upload: false,
      downPlugDialog: false,
      submitType: "",
      downPlugForm: { remark: "", id: "", sortNum: "" },
      fileList: [],
      manualList: [],
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      pageLayout: "total, prev, pager, next,jumper", // 分页组件
      searchQuery: { isEnable: "", fileName: "" },
      loading: false,
      isqiyongoptions: [
        {
          id: 0,
          label: "启用"
        },
        {
          id: 1,
          label: "禁用"
        }
      ]
    };
  },
  computed: {
    downPlugTitle() {
      return ["添加", "修改"][this.submitType];
    }
  },
  created() {
    this.getList(1);
  },
  methods: {
    async getList(index) {
      const {
        searchQuery: { isEnable, fileName },
        pageSize
      } = this;
      const params = {
        pageSize,
        pageNo: index,
        pageNum: index,
        isEnable,
        fileName
      };
      const { data, pageIndex, totalCount } = await request.queryManualList(params);
      this.manualList = data;
      this.totalCount = totalCount;
      this.pageIndex = pageIndex;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(1);
    },
    uploadBtn() {
      this.downPlugDialog = true;
      this.submitType = 0;
    },
    async httpRequest({ file }) {
      this.loading = true;
      const data = new FormData();
      data.append("file", file);
      const res = await request.manualUpload(data);
      const list = [res.data];
      this.loading = false;
      this.fileList = list.map((item) => {
        return {
          fileId: item.fileKey,
          fileName: item.realName,
          fileType: parseInt(item.fileType),
          filePath: item.filePath
        };
      });
    },
    className(row) {
      return tableRowIcon(row);
    },
    deleteRow(index) {
      this.fileList.splice(index, 1);
    },
    uploadRowType(row) {
      const fileUrl = scanzhizhao(row.filePath);
      downloadFile(fileUrl);
    },
    clickClose() {
      this.fileList = [];
      this.getList(1);
      this.$nextTick(() => {
        this.downPlugDialog = false;
        this.$refs.downPlugForm.resetFields();
      });
    },
    async sureChangeRemark() {
      if (!this.fileList.length) {
        this.$message.warning("请先上传文件");
        return;
      }
      const {
        downPlugForm: { remark, id, sortNum },
        fileList,
        submitType
      } = this;
      const params = {
        fileId: fileList[0].fileId,
        fileName: fileList[0].fileName,
        fileType: fileList[0].fileType,
        filePath: fileList[0].filePath,
        remark,
        sortNum
      };
      if (submitType === 0) {
        await request.addManual(params);
      } else {
        params.id = id;
        await request.updateManual(params);
      }
      await this.clickClose();
    },
    async update(row) {
      this.submitType = 1;
      this.downPlugDialog = true;
      const res = await request.queryManualDetail(row.id);
      this.downPlugForm = res.data;
      this.fileList = [res.data];
    },
    async enableBtn(row) {
      await request.queryManualEnable(row.id);
      await this.getList(1);
    },
    async disableBtn(row) {
      await request.queryManualDisable(row.id);
      await this.getList(1);
    }
  }
};
</script>

<style lang="scss" scoped>
$header-height: 56px;
.mainAll {
  height: 100%;
  position: relative;
  background-color: #fff;
}
.header_h {
  font-size: 16px;
  font-weight: 600;
  height: $header-height;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebefff;
  padding: 0 var(--big-space);
}
.form {
  width: 100%;
  .el-form-item{
    &:last-child{
      margin-right: 0 !important;
    }
    margin-bottom: 0 !important;
  }
}
.midd {
  position: absolute;
  top: $header-height;
  left: 0;
  right: 0;
  bottom: calc(32px + var(--middle-space));
  padding: var(--big-space);
}
.page-1 {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: var(--middle-space) var(--big-space);
}
::v-deep .cell {
  font-size: 14px;
  span{
    font-size: 14px;
  }
}
</style>
